export const deserializeHtmlItalic = [
  { validNodeName: ['EM', 'I'] },
  {
    validStyle: {
      fontStyle: 'italic',
    },
  },
];
